import { render } from "./newToDoModal.vue?vue&type=template&id=2e575f2b&ts=true"
import script from "./newToDoModal.vue?vue&type=script&lang=ts"
export * from "./newToDoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__